import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0257c707&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=0257c707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257c707",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0257c707')) {
      api.createRecord('0257c707', component.options)
    } else {
      api.reload('0257c707', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0257c707&scoped=true&", function () {
      api.rerender('0257c707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_invoice-disputes/index.vue"
export default component.exports